import { get, post } from './wrapper'

export const getBoard = (board, params) => get(`board/${board}`, params)



// WEBPACK FOOTER //
// ./src/api/board.js